import { FunctionComponent, memo, useRef } from "react";
import { Tooltip } from "@edgetier/components";
import { useIsOverflowed } from "@edgetier/utilities";

import { IProps } from "./anomaly-proportion-bar-label.types";
import "./anomaly-proportion-bar-label.scss";

/**
 * A label that will display the text provided and display the text in a tooltip if the text is overflowed.
 * @param props.label The label to be displayed.
 */
const AnomalyProportionBarLabel: FunctionComponent<IProps> = ({ label }) => {
    const labelRef = useRef<HTMLLabelElement>(null);
    const isOverflowed = useIsOverflowed(labelRef);

    return (
        <Tooltip
            content={<div className="anomaly-proportion-bar-label__tooltip-content">{label}</div>}
            delayEnter={250}
            disableTooltip={!isOverflowed}
            useArrow
        >
            <label className="anomaly-proportion-bar-label" htmlFor={label} ref={labelRef}>
                {label}
            </label>
        </Tooltip>
    );
};

export default memo(AnomalyProportionBarLabel);
